import React, { useState, useContext, useMemo } from 'react';
import { AppContext } from '@/contexts/AppContext';
import logo from '@/assets/images/logo-editada.png';

import ProductManagement from './ProductManagement';
import SpecialOffersManagement from './SpecialOffersManagement';
// import CouponsManagement from './CouponsManagement';
import CategoriesManagement from './CategoriesManagement';
import OrdersManagement from './OrdersManagement';
import ClientsManagement from './ClientsManagement';

const AdminPanel = () => {
  const { isAdminAuthenticated, adminLogin, adminLogout } = useContext(AppContext)!;

  const [loginForm, setLoginForm] = useState({ email: '', password: '' });
  const [loginError, setLoginError] = useState('');
  const [currentSection, setCurrentSection] = useState('products');

  const sections = useMemo(
    () => [
      { key: 'products', label: 'Produtos', component: <ProductManagement /> },
      { key: 'categories', label: 'Categorias', component: <CategoriesManagement /> },
      { key: 'offers', label: 'Ofertas Especiais', component: <SpecialOffersManagement /> },
      // { key: 'coupons', label: 'Cupons', component: <CouponsManagement /> },
      { key: 'orders', label: 'Pedidos', component: <OrdersManagement /> },
      { key: 'clients', label: 'Clientes', component: <ClientsManagement /> },
    ],
    [],
  );

  const handleLoginChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setLoginForm(prev => ({ ...prev, [name]: value }));
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    const success = await adminLogin(loginForm.email, loginForm.password);
    if (success) {
      setLoginError('');
    } else {
      setLoginError('Credenciais inválidas');
    }
  };

  if (!isAdminAuthenticated) {
    return (
      <div className="admin-login">
        <div className="login-form-container">
          <div className="login-logo">
            <img src={logo} alt="A Casa dos Gatos" />
            <h2>Área Administrativa</h2>
            <p>Faça login para gerenciar produtos, pedidos e promoções.</p>
          </div>
          <form className="login-form" onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="admin-email">E-mail</label>
              <input
                id="admin-email"
                type="email"
                name="email"
                value={loginForm.email}
                onChange={handleLoginChange}
                placeholder="seu-email@exemplo.com"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="admin-password">Senha</label>
              <input
                id="admin-password"
                type="password"
                name="password"
                value={loginForm.password}
                onChange={handleLoginChange}
                placeholder="Digite sua senha"
                required
              />
            </div>
            {loginError && (
              <div className="error-message" role="alert">
                {loginError}
              </div>
            )}
            <div className="login-actions">
              <button type="submit" className="login-button">
                Entrar
              </button>
              <button
                type="button"
                className="forgot-password-button"
                onClick={() => {
                  window.alert('Para redefinir sua senha, entre em contato com o administrador do sistema.');
                }}
              >
                Esqueci minha senha
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-panel">
      <div className="admin-container">
        <header className="admin-header">
          <div className="logo">
            <img src={logo} alt="A Casa dos Gatos" className="logo-icon" />
            <div>
              <h2>Painel Administrativo</h2>
              <p>Gerencie produtos, categorias, pedidos e muito mais.</p>
            </div>
          </div>
          <button type="button" className="logout-button" onClick={adminLogout}>
            Sair
          </button>
        </header>

        <div className="admin-layout">
          <aside className="admin-sidebar">
            {sections.map(section => (
              <button
                key={section.key}
                type="button"
                onClick={() => setCurrentSection(section.key)}
                className={currentSection === section.key ? 'active' : ''}
              >
                {section.label}
              </button>
            ))}
          </aside>

          <main className="admin-content">
            {sections.map(section => (
              currentSection === section.key ? <div key={section.key}>{section.component}</div> : null
            ))}
          </main>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;